import React from "react";
import Spacing from "../Spacing";
import SectionHeadingStyle3 from "../SectionHeading/SectionHeadingStyle3";
import AboutStyle7 from "../About/AboutStyle7";
import AboutStyle8 from "../About/AboutStyle8";
import { pageTitle } from "../../helpers/PageTitle";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";
import parse from 'html-react-parser';

export default function CaseStudyDetailsPage() {
  const { t } = useTranslation();
  pageTitle(t("caseStudyDetails.merchandising.pageTitle"));

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title={t("caseStudyDetails.merchandising.title")}
        subTitle={t("caseStudyDetails.merchandising.subTitle")}
        variant="text-center"
      />
      <Spacing lg="75" md="60" />

      <div className="container">
        <img
          className="cs_casestudy_details_thumb cs_radius_15"
          src="\images\unalom\merchandasin_1.jpeg"
          alt={t("caseStudyDetails.merchandising.imgAlt")}
        />

        <div className="cs_height_100 cs_height_lg_60" />
        <div className="row align-items-center cs_gap_y_35">
          <div className="col-lg-5">
            <img
              src="\images\unalom\diseno_producto.png"
              alt={t("caseStudyDetails.merchandising.imgAlt")}
              className="cs_radius_15 w-100"
            />
          </div>
          <div className="col-lg-6 offset-lg-1">
            <h2 className="cs_fs_50">{t("caseStudyDetails.merchandising.section1.title")}</h2>
            <div className="cs_height_15 cs_height_lg_15" />
            <p>
              {parse(t("caseStudyDetails.merchandising.section1.description"))}
            </p>
            <div className="cs_height_20 cs_height_lg_10" />
          </div>
        </div>
      </div>
      <a
        href="https://calendly.com/nicolas-rs/new-meeting"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="text-center">
          <Spacing lg="80" md="50" />
          <span className="cs_btn cs_style_1">
            {t("caseStudyDetails.merchandising.button")}
            <span>
              <i>
                <Icon icon="fa6-solid:arrow-right" />
              </i>
              <i>
                <Icon icon="fa6-solid:arrow-right" />
              </i>
            </span>
          </span>
        </div>
      </a>
      <Spacing lg="150" md="80" />
      <AboutStyle7
        title={t("caseStudyDetails.merchandising.section2.title")}
        subTitle={t("caseStudyDetails.merchandising.section2.description")}
        featureList={t("caseStudyDetails.merchandising.section2.features", { returnObjects: true })}
        thumbnailSrc="/images/unalom/diseno.jpeg"
      />
      <a
        href="https://calendly.com/nicolas-rs/new-meeting"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="text-center">
          <Spacing lg="80" md="50" />
          <span className="cs_btn cs_style_1">
            {t("caseStudyDetails.merchandising.button")}
            <span>
              <i>
                <Icon icon="fa6-solid:arrow-right" />
              </i>
              <i>
                <Icon icon="fa6-solid:arrow-right" />
              </i>
            </span>
          </span>
        </div>
      </a>
      <Spacing lg="150" md="80" />
      <AboutStyle8
        thumbnailSrc="/images/unalom/merchandising.jpeg"
        title={t("caseStudyDetails.merchandising.section3.title")}
        subTitle={t("caseStudyDetails.merchandising.section3.description")}
        grothData={t("caseStudyDetails.merchandising.section3.metrics", { returnObjects: true })}
      />
      <a
        href="https://calendly.com/nicolas-rs/new-meeting"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="text-center">
          <Spacing lg="80" md="50" />
          <span className="cs_btn cs_style_1">
            {t("caseStudyDetails.merchandising.button")}
            <span>
              <i>
                <Icon icon="fa6-solid:arrow-right" />
              </i>
              <i>
                <Icon icon="fa6-solid:arrow-right" />
              </i>
            </span>
          </span>
        </div>
      </a>
      <Spacing lg="140" md="70" />
    </>
  );
}
